import createReducer from '../../utils/createReducer';
import actionPrefix from '../../utils/actionPrefix';
import { getRecentActivity } from '../../api/clients/recentActivity';

const initialState = {
  data: [],
  error: {},
  limit: 8,
  loading: false,
  title: ''
};

const prefix = actionPrefix('recentActivity');

// Actions
const FETCH_REQUEST = prefix('FETCH_REQUEST');
const FETCH_ERROR = prefix('FETCH_ERROR');
const FETCH_SUCCESS = prefix('FETCH_SUCCESS');

// Reducers
export default createReducer(initialState, {
  [FETCH_REQUEST](state, { payload }) {
    return {
      ...state,
      ...payload,
      loading: true
    };
  },
  [FETCH_ERROR](state, { payload }) {
    return {
      ...initialState,
      error: payload
    };
  },
  [FETCH_SUCCESS](state, { payload }) {
    const { data, ...props } = payload;
    return {
      ...state,
      ...props,
      loading: false,
      data: data.slice(0, state.limit)
    };
  }
});

// Action creators
export const request = payload => ({
  type: FETCH_REQUEST,
  payload
});

export const throwError = payload => ({
  type: FETCH_ERROR,
  payload
});

export const success = payload => ({
  type: FETCH_SUCCESS,
  payload
});

// Effects
export const fetchRecentActivity = options => (dispatch) => {
  dispatch(request(options));
  getRecentActivity()
    .then(data => dispatch(success(data)))
    .catch(({ message }) => dispatch(throwError(message)));
};
